module.exports = __webpack_public_path__ + "static/img/0400.d42a25e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0400.jpg
// module id = zwNl
// module chunks = 2